import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export function getNestedValue(obj: any, path: any) {
  return path.split(".").reduce((acc: any, part: any) => acc && acc[part], obj);
}

export const downloadExcelForDataGrid = ({
  rows,
  columns,
  fileName,
}: {
  rows: any[];
  columns: any[];
  fileName?: string;
}) => {
  const worksheet = XLSX.utils.json_to_sheet(
    rows.map((row) => {
      return columns.reduce((acc: Record<string, any>, column) => {
        acc[column.headerName] = getNestedValue(row, column.field) || "-";
        return acc;
      }, {});
    })
  );

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, fileName || "table_data.xlsx");
};
